module.exports = __webpack_public_path__ + "img/landing-box.68ce125c.svg";